var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "alt-header" },
        [
          _c(
            "ContentHeader",
            { attrs: { title: _vm.pageTitle, bordered: false } },
            [
              _c("template", { slot: "custom-back" }, [_vm._t("back")], 2),
              _vm._v(" "),
              _vm.can("createInsights")
                ? _c(
                    "template",
                    { slot: "actions" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn--primary",
                          attrs: { to: { name: "create-document" } },
                        },
                        [
                          _vm._v(
                            "\n                        Create Document\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.can("createInsightCategories")
                ? _c(
                    "template",
                    { slot: "title-extra" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "small-edit",
                          attrs: {
                            to: {
                              name: "edit-document-category",
                              params: { category_id: _vm.type },
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Edit")]),
                          _vm._v(" "),
                          _c("SvgIcon", {
                            attrs: { icon: "edit", "is-filled": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filters" },
        [
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.filteredFilters.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.filteredFilters, "sectors", $$v)
              },
              expression: "filteredFilters.sectors",
            },
          }),
          _vm._v(" "),
          !_vm.hideCategory
            ? _c("FormControlInsightCategory", {
                attrs: {
                  name: "category",
                  multiple: true,
                  "include-ancestors": false,
                },
                model: {
                  value: _vm.filteredFilters.category,
                  callback: function ($$v) {
                    _vm.$set(_vm.filteredFilters, "category", $$v)
                  },
                  expression: "filteredFilters.category",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: {
              name: "member",
              placeholder: "Select...",
              label: "Member company",
            },
            model: {
              value: _vm.filteredFilters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filteredFilters, "member", $$v)
              },
              expression: "filteredFilters.member",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "fromDate", label: "From date" },
            model: {
              value: _vm.filteredFilters.fromDate,
              callback: function ($$v) {
                _vm.$set(_vm.filteredFilters, "fromDate", $$v)
              },
              expression: "filteredFilters.fromDate",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "toDate", label: "To date" },
            model: {
              value: _vm.filteredFilters.toDate,
              callback: function ($$v) {
                _vm.$set(_vm.filteredFilters, "toDate", $$v)
              },
              expression: "filteredFilters.toDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__group search",
          attrs: { slot: "search" },
          slot: "search",
        },
        [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "local-search" } },
            [_vm._v("Search Insights")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            staticClass: "form__control search",
            attrs: {
              id: "local-search",
              type: "search",
              placeholder: "Search Insights...",
            },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "all", title: "All Insights" } },
            [
              _c("ListInsights", {
                ref: "all",
                attrs: { "load-on-start": false, filters: _vm.filters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "mine", title: "My Insights" } },
            [
              _c("ListInsights", {
                ref: "mine",
                attrs: {
                  "load-on-start": false,
                  filters: _vm.filters,
                  "mine-only": true,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }